import { Group, Button, NumberInput } from '@mantine/core';
import { useForm } from '@mantine/form';

import type { TShopCommissionUpdateParams, TShopCommission } from '../store/types';

type FormData = TShopCommissionUpdateParams;

type Props = {
  commission: TShopCommission;
  onSubmit: (params: TShopCommissionUpdateParams) => void;
  onClose: () => void;
};

export const EditShopCommissionForm = (props: Props) => {
  const {
    commission,
    onSubmit,
    onClose,
  } = props;

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      commissionId: commission.id,
      refillPercent: commission.refillPercent,
      additionalPercent: commission.additionalPercent,
    },
    validate: {
      commissionId: (value) => !value ? 'Введите ID комиссии' : null,
      refillPercent: (value) => value !== 0 && !value ? 'Введите процент пополнения' : null,
    },
  });

  const handleSubmit = (values: FormData) => {
    onSubmit(values);
    onClose();
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <NumberInput
        label="ID комиссии"
        placeholder=""
        disabled
        key={form.key('commissionId')}
        {...form.getInputProps('commissionId')}
      />
      <NumberInput
        label="Процент пополнения"
        placeholder=""
        decimalScale={10}
        step={0.1}
        min={0}
        max={100}
        key={form.key('refillPercent')}
        {...form.getInputProps('refillPercent')}
      />
      <NumberInput
        label="Комиссия с клиента (%)"
        placeholder=""
        decimalScale={10}
        step={0.1}
        min={0}
        max={100}
        key={form.key('additionalPercent')}
        {...form.getInputProps('additionalPercent')}
      />

      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit">
          Редактировать
        </Button>
      </Group>
    </form>
  );
};
